import http from "./helpers/httpInterceptor";
import { downloadFile } from "@/utils";

const endpoint = {
  import: "/tms/check-in-out/import-gdc-time-sheet-sync?type=overwrite",
  getTemplate: "/tms/check-in-out/timesheet/import-file/template",
};

const TIMESHEET_ROOT = "tms/timesheets";

const state = () => ({
  timesheetPayrollPeriodList: [],
  noteList: [],
  timesheetAllUser: [],
  timesheetUser: {},
  commentList: [],
  calculationWorking: {},
  ruleIntegration: [],
  updateHistory: [],
});

// mutations
const mutations = {
  TIMESHEET_BY_PAYROLL_PERIOD_LIST(states, data) {
    states.timesheetPayrollPeriodList = data;
  },
  NOTE_LIST(states, data) {
    states.noteList = data;
  },
  ALL_USER_TIMESHEET(states, data) {
    states.timesheetAllUser = data;
  },
  USER_TIMESHEET(states, data) {
    states.timesheetUser = data;
  },
  COMMENT_LIST(states, data) {
    states.commentList = data;
  },
  CALCULATION_WORKING(states, data) {
    states.calculationWorking = data;
  },
  RULE_INTEGRATION(states, data) {
    states.ruleIntegration = data;
  },
  UPDATE_HISTORY(states, data) {
    states.updateHistory = data;
  },
};

// actions
const actions = {
  getTimesheetByPayrollPeriod({ commit, dispatch }, url) {
    dispatch("user/loadingRequest", true);
    return http
      .get(TIMESHEET_ROOT + url)
      .then((res) => {
        commit("TIMESHEET_BY_PAYROLL_PERIOD_LIST", res.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  getNotes({ commit }) {
    return http
      .get("tms/settings/notes")
      .then((res) => {
        commit("NOTE_LIST", res.data.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  getAllUserTimesheet({ commit }, params) {
    return http
      .get(TIMESHEET_ROOT + `/${params.timesheetId}/statistic${params.paramFilter}`)
      .then((res) => {
        commit("ALL_USER_TIMESHEET", res.data.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  getUserTimesheet({ commit }, params) {
    return http
      .get(TIMESHEET_ROOT + `/${params.timesheetId}/employee/${params.employmentID}`)
      .then((res) => {
        commit("USER_TIMESHEET", res.data.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getUserTimesheetFlexible({ commit }, params) {
    return http
      .get(TIMESHEET_ROOT + `/flexible/${params.timesheetId}/employee/${params.employmentID}`)
      .then((res) => {
        commit("USER_TIMESHEET", res.data.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  getCommentsTimesheet({ commit }, timesheetId) {
    return http
      .get(TIMESHEET_ROOT + `/${timesheetId}/comments`)
      .then((res) => {
        commit("COMMENT_LIST", res.data.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  getCalculationWorkingEmployee({ commit }, params) {
    return http
      .get(TIMESHEET_ROOT + `/get-calculate-my-timesheet?id=${params.timesheetId}&employmentID=${params.employmentID}`)
      .then((res) => {
        commit("CALCULATION_WORKING", res.data.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  getRuleIntegration({ commit }) {
    return http
      .get("tms/rule-integration/value")
      .then((res) => {
        commit("RULE_INTEGRATION", res.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  updateHistory({ commit }, params) {
    return http
      .put(`/tms/timesheets/update-job-history?userId=${params.sf4cId}`)
      .then((res) => {
        commit("UPDATE_HISTORY", res);
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },

  importFile(_, payload) {
    const formData = new FormData();
    formData.append("file", payload[0]);
    return http
      .post(endpoint.import, formData, { responseType: "blob" })
      .then((res) => {
        if (res.headers.code !== 200) {
          const fileName = res.headers.fileName ?? "ImportGDCTimeSheetResult.xlsx";
          downloadFile(res.data, fileName);
        }
        return res;
      })
      .catch((error) => {
        throw error;
      });
  },

  importFileRequest(_, payload) {
    const formData = new FormData();
    formData.append("file", payload[0]);
    return http
      .post("/tms/request-management/import-gdc-request-time-off-sync", formData, { responseType: "blob" })
      .then((res) => {
        if (res.headers.code !== 200) {
          const fileName = res.headers.fileName ?? "ImportFileRequestResult.xlsx";
          downloadFile(res.data, fileName);
        }
        return res;
      })
      .catch((error) => {
        throw error;
      });
  },

  importFileRequestRevoke(_, payload) {
    const formData = new FormData();
    formData.append("file", payload[0]);
    return http
      .post("/tms/request-management/import-gdc-request-time-off-revoke-sync", formData, { responseType: "blob" })
      .then((res) => {
        if (res.headers.code !== 200) {
          const fileName = res.headers.fileName ?? "ImportFileRequestRevokeResult.xlsx";
          downloadFile(res.data, fileName);
        }
        return res;
      })
      .catch((error) => {
        throw error;
      });
  },

  importFileOvertime(_, payload) {
    const formData = new FormData();
    formData.append("file", payload[0]);
    return http
      .post("/tms/overtime-management/v2/import-gdc-over-time-sheet-sync?type=overwrite", formData, { responseType: "blob" })
      .then((res) => {
        if (res.headers.code !== 200) {
          const fileName = res.headers.fileName ?? "ImportFileOvertimeResult.xlsx";
          downloadFile(res.data, fileName);
        }
        return res;
      })
      .catch((error) => {
        throw error;
      });
  },

  downloadTemplate() {
    return http
      .get(endpoint.getTemplate, { responseType: "blob" })
      .then((res) => {
        const fileName = res.headers.fileName ?? res.headers.filename ?? "Template.xlsx";
        downloadFile(res.data, fileName);
        return res;
      })
      .catch((error) => {
        throw error;
      });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
